import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.payment}files/${COMMON_QUERY_PARAMS.FILE_ID}/services`;

export interface CreatePaymentFromDirectPaymentServiceTypeCommandArgs {
  fileId: string;
  serviceIds: string[];
  paymentMethod?: string;
  redirectLocalhost?: boolean;
}

const createPaymentFromDirectPaymentServiceTypeCommand = async ({
  fileId,
  serviceIds,
  paymentMethod,
  redirectLocalhost,
}: CreatePaymentFromDirectPaymentServiceTypeCommandArgs): Promise<
  BackResponse<string> | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId);

    return await apiCall<BackResponse<string>>(url, {
      method: SUPPORTED_METHODS.POST,
      json: {
        serviceIds,
        paymentMethod,
        redirectLocalhost,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
};

export default createPaymentFromDirectPaymentServiceTypeCommand;
